import { render, staticRenderFns } from "./TrustPilot.vue?vue&type=template&id=d3ae642a&scoped=true&"
import script from "./TrustPilot.vue?vue&type=script&lang=js&"
export * from "./TrustPilot.vue?vue&type=script&lang=js&"
import style0 from "./TrustPilot.vue?vue&type=style&index=0&id=d3ae642a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3ae642a",
  null
  
)

export default component.exports